import { InspectionType } from "commons/enum/inspection";

export const getInspectionTypeName = (type: InspectionType): string => {
  switch (type) {
    case InspectionType.Stella:
      return "Stella";
    case InspectionType.DualLang:
      return "Song Ngữ";
    default:
      return "";
  }
};
